module.exports = __webpack_public_path__ + "static/media/08.54a46762.mp3";